import { Link, useNavigate } from "react-router-dom";
import { Box, Progressbar, Button, Heading } from "@ogt/ui";
import { URLS } from "src/config/urls";

export default function Intro() {
  const navigate = useNavigate();
  const progress = 0;

  return (
    <div>
      <div className="flex justify-end items-center">
        <div className="w-full max-w-xs mb-4">
          <Progressbar percentage={progress} />
        </div>
      </div>
      <Box>
        <Heading>Innan du börjar</Heading>
        <ul>
          <li>
            Se till att du har kvitton om du behövt åka taxi (bild räcker).
          </li>
          <li>
            Har du rest med Resplusbiljett? Ansök om{" "}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to={URLS.resplusDelayCompensation}
            >
              förseningsersättning hos Samtrafiken.
            </Link>
          </li>
          <li>
            Har du rest med färdtjänst eller sjukresa?{" "}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to={URLS.paratransitDelayCompensation}
            >
              Ansök om förseningsersättning för färdtjänst och sjukresa här
            </Link>
            .
          </li>
          <li>
            Har du rest med Krösatåg över länsgränsen? Ansök om{" "}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to={URLS.kalmarDelayCompensation}
            >
              förseningsersättning hos Kalmar länstrafik.
            </Link>
          </li>
        </ul>
        <p>
          Om du stöter på frågor längs vägen är du välkommen att höra av dig
          till kundservice.
        </p>
      </Box>

      <div className="flex justify-center">
        <div className="w-full text-right">
          <Button
            onClick={() => navigate("/hur-du-reste")}
            className="w-full sm:w-auto"
            variant={"primary"}
            type="submit"
          >
            Börja ansöka
          </Button>
        </div>
      </div>
    </div>
  );
}
